/*
 * 上传文件
 *
 * @Author: xiaoJQ
 * @Date: 2024-06-07 17:32:31
 *
 * Copyright © 2024 kingdee.com. All Rights Reserved.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useCallback, useEffect, useMemo, useRef, useState, } from 'react';
import { connect, useDispatch } from 'react-redux';
import { message } from 'antd';
import { Select } from '@kdcloudjs/kdesign';
import { v4 } from 'uuid';
import classNames from 'classnames';
import { useSelector } from 'store/hook/useSelector';
import { changeMainPageFileAction, outputMsg } from 'store/actioin/action';
import Attachment from 'components/attachment';
import { isValidKey, promiseType, request } from 'components/util/util';
import positionStyles from 'components/position.less';
import utilStyles from 'components/util.less';
import Modal from 'components/common/modal';
import Icons from 'Icon/Icons.less';
import { Pdf_svg, Pic_svg, Wps_svg, Word_svg, Ofd_svg } from 'image/index';
import Styles from './index.less';
import { startExtract } from '../../api/app';
var UploadFile = function (props) {
    var dispatch = useDispatch();
    var inputFRef = useRef(null);
    var model = useSelector(function (state) { var _a; return (_a = state.global) === null || _a === void 0 ? void 0 : _a.model; });
    var _a = useState(false), showAttachment = _a[0], setShowAttachment = _a[1];
    var _b = useState({
        status: false,
        callback: null,
    }), saveAttachment = _b[0], setSaveAttachment = _b[1];
    var changeFiles = function () {
        if (inputFRef.current) {
            var file = inputFRef.current.files &&
                inputFRef.current.files.length > 0 &&
                inputFRef.current.files[0];
            var type = inputFRef.current.value
                .slice(inputFRef.current.value.lastIndexOf('.') + 1)
                .toLowerCase();
            if (isValidKey(type, promiseType) && promiseType[type] === true) {
                if (file && file.size > 50 * 1024 * 1024) {
                    dispatch(outputMsg('文件大小不符合要求。'));
                    return;
                }
                else {
                    if (inputFRef.current.files) {
                        dispatch(changeMainPageFileAction(inputFRef.current.files[0].name, type, '', 'loading', true));
                        // toBase(inputFRef.current.files[0], type)
                        postFile(inputFRef.current.files[0], type);
                    }
                }
            }
            else if (type !== undefined && type !== '') {
                inputFRef.current.value = '';
                dispatch(outputMsg('暂不支持该文件类型，请重新上传。'));
            }
        }
    };
    var toBase = function (file, type) {
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
            setTimeout(function () {
                dispatch(changeMainPageFileAction(file.name, type, reader.result, 'success', true));
            }, 200);
        };
    };
    var postFile = function (file, type) { return __awaiter(void 0, void 0, void 0, function () {
        var form;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    form = new FormData();
                    form.append('file', file);
                    form.append('url', file.name);
                    form.append('urlType', 'pc');
                    form.append('appId', 'cvp');
                    form.append('fId', 'cvp_tda_plan');
                    form.append('token', v4());
                    return [4 /*yield*/, request("".concat(props.global.serverUrl), {
                            method: 'POST',
                            body: form,
                        }, function (res) {
                            if (res.status === 'success') {
                                setTimeout(function () {
                                    dispatch(changeMainPageFileAction(file.name, type, res.url, 'loading', true));
                                    model.invokeAsync('validExtractFile', {
                                        fileName: file.name,
                                        url: res.url,
                                        type: '',
                                    });
                                }, 2000);
                            }
                            else {
                                dispatch({
                                    type: 'outputMsg',
                                    payload: res.description,
                                });
                                console.error(res.description);
                                setTimeout(function () {
                                    dispatch(changeMainPageFileAction(file.name, type, res.url, 'error', false));
                                }, 2000);
                            }
                        })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var handleExtract = function (planId, pageSelectionType, freeSelection) {
        var _a;
        if (pageSelectionType &&
            ((_a = props.file.mainpage) === null || _a === void 0 ? void 0 : _a.status) === 'success' &&
            props.file.mainpage.hasData) {
            dispatch({
                type: 'changeDisplayPageFile',
                payload: {
                    name: props.file.mainpage.name,
                    type: props.file.mainpage.name
                        .slice(props.file.mainpage.name.lastIndexOf('.') + 1)
                        .toLowerCase(),
                },
            });
            dispatch({
                type: 'startExtract',
                payload: {
                    data: {
                        status: "loading",
                    },
                    control: { activeView: 'displaypage' },
                },
            });
            startExtract(model, {
                planId: planId,
                file: {
                    fileName: props.file.mainpage.name,
                    name: props.file.mainpage.name,
                    url: props.file.mainpage.url,
                    tempFileId: props.file.mainpage.tempFileId,
                },
                pageSelection: {
                    type: pageSelectionType,
                    freeSelection: freeSelection,
                },
            });
        }
        else {
            console.error('文件上传失败或文件缺失。');
            dispatch(outputMsg('文件上传失败或文件缺失。'));
            dispatch({ type: 'backHomePage', payload: 'backHomePage' });
        }
    };
    var getAttachmentList = function () {
        model === null || model === void 0 ? void 0 : model.invokeAsync('getAttachmentList', props.global.billId);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Modal, { visibily: showAttachment, title: '附件列表', width: 960, height: 563, onCancel: function () { return setShowAttachment(false); }, onOk: function () {
                setSaveAttachment({
                    status: true,
                    callback: function () {
                        setShowAttachment(false);
                    },
                });
            } },
            React.createElement(Attachment, { saveAttachment: saveAttachment, setSaveAttachment: setSaveAttachment })),
        React.createElement("div", { className: Styles.uploadFileBox },
            React.createElement("div", { className: classNames(Styles.uploadArea, positionStyles.inTheMiddle) },
                React.createElement("input", { className: Styles.fileInput, 
                    // accept={".docx,.doc,.png,.jpg,.jepg,.pdf"}
                    accept: '.docx,.doc,.png,.jpg,.jpeg,.pdf,.bmp,.tiff,.tif,.wps,.ofd', onChange: function () { return changeFiles(); }, ref: inputFRef, type: 'file' }),
                React.createElement("div", { className: classNames(Styles.uploadAndPageSelected, positionStyles.inTheMiddle) },
                    React.createElement("div", { className: Styles.uploadFilePath },
                        React.createElement(UploadFileComponent, { viewType: props.global.viewType, fileInfo: props.file.mainpage, inputRef: inputFRef, onChange: changeFiles, getAttachmentList: getAttachmentList, setShowAttachment: setShowAttachment, attachmentUpload: props.control.attachmentUpload })),
                    React.createElement(PageSelection, { fileInfo: props.file.mainpage, planList: props.global.planList, onExtract: handleExtract })),
                React.createElement("span", { className: Styles.uploadDesc }, "1.\u652F\u6301doc\u3001docx\u3001pdf\u3001jpg\u3001jpeg\u3001bmp\u3001png\u3001wps\u3001ofd\u683C\u5F0F\u3002"),
                React.createElement("span", { className: Styles.uploadDesc }, "2.\u6587\u4EF6\u5927\u5C0F\u4E0D\u8D85\u8FC750M\u3001\u9875\u6570\u4E0D\u8D85\u8FC7500\u9875\u3002")))));
};
var PageSelection = function (_a) {
    var _b, _c;
    var fileInfo = _a.fileInfo, _d = _a.planList, planList = _d === void 0 ? [] : _d, onExtract = _a.onExtract;
    var _e = useState(false), showTips = _e[0], setShowTips = _e[1];
    var _f = useState(''), freeSelectionValue = _f[0], setFreeSelectionValue = _f[1];
    var _g = useState(1), selectedRadio = _g[0], setSelectedRadio = _g[1];
    var _h = useState(''), currentSelect = _h[0], setCurrentSelect = _h[1];
    var options = useMemo(function () {
        return planList.map(function (item) { return ({
            value: item.planId,
            label: item.planName,
        }); });
    }, [planList]);
    var checkExtractCondition = useCallback(function () {
        if (!currentSelect) {
            message.error('提取方案不能为空');
            return;
        }
        if (!selectedRadio) {
            message.error('提取范围不能为空');
            return;
        }
        if (currentSelect && selectedRadio) {
            onExtract(currentSelect, selectedRadio, freeSelectionValue);
        }
    }, [currentSelect, selectedRadio, freeSelectionValue, onExtract]);
    var handleSelectChange = useCallback(function (value) {
        setCurrentSelect(value);
    }, []);
    useEffect(function () {
        var _a;
        setCurrentSelect((_a = planList[0]) === null || _a === void 0 ? void 0 : _a.planId);
    }, [planList]);
    return (React.createElement("div", { className: classNames(Styles.pageSelected, positionStyles.inTheMiddle) },
        React.createElement("div", { className: Styles.pageSelectedBody },
            options.length > 1 ? (React.createElement(React.Fragment, null,
                React.createElement("div", { className: Styles.pageSelectedBodyNav },
                    React.createElement("span", null, "\u63D0\u53D6\u65B9\u6848\uFF1A")),
                React.createElement(Select, { placeholder: "\u8BF7\u9009\u62E9\u63D0\u53D6\u65B9\u6848", borderType: "bordered", className: classNames(Styles.select), value: currentSelect, onChange: handleSelectChange, options: options }))) : null,
            React.createElement("div", { className: Styles.pageSelectedBodyNav },
                React.createElement("span", null, "\u63D0\u53D6\u8303\u56F4\uFF1A")),
            React.createElement("div", { className: classNames(Styles.pageSelectedBodyContent, positionStyles.inTheMiddle) },
                React.createElement("div", { className: classNames(Styles.fixedSelection, positionStyles.inTheMiddle) },
                    React.createElement(RadioBtn, { value: 1, selectedRadio: selectedRadio, setSelectedRadio: setSelectedRadio },
                        React.createElement("span", null, "\u6587\u6863\u524D5\u9875\u548C\u540E5\u9875")),
                    React.createElement(RadioBtn, { value: 2, selectedRadio: selectedRadio, setSelectedRadio: setSelectedRadio },
                        React.createElement("span", null, "\u6240\u6709\u9875\u9762"))),
                React.createElement("div", { className: Styles.freeSelection },
                    React.createElement(RadioBtn, { value: 3, selectedRadio: selectedRadio, setSelectedRadio: setSelectedRadio },
                        React.createElement(React.Fragment, null,
                            React.createElement("span", null, "\u81EA\u5B9A\u4E49"),
                            React.createElement("span", { onMouseEnter: function () { return setShowTips(true); }, onMouseOver: function () { return setShowTips(true); }, onMouseLeave: function () { return setShowTips(false); }, className: classNames(Icons['icon-size'], Icons['icon-tips']) },
                                React.createElement("div", { style: { display: showTips ? 'flex' : 'none' }, className: Styles.freeSelectionTips }, "\u8BF7\u8F93\u5165\u9875\u9762\u8303\u56F4\uFF0C\u7528\u9017\u53F7\u5206\u9694\uFF0C\u4F8B\u5982\uFF1A1,3,5-12")),
                            React.createElement("input", { type: 'text', value: freeSelectionValue, placeholder: '例：1,3,5-12', className: Styles.freeSelectionInput, onChange: function (e) { return setFreeSelectionValue(e.target.value); } })))))),
        React.createElement("div", { className: classNames(Styles.pageSelectedFooter, positionStyles.inTheMiddle) },
            React.createElement("div", { onClick: function () {
                    if (fileInfo.status === 'success') {
                        checkExtractCondition();
                    }
                }, className: classNames(positionStyles.inTheMiddle, (_b = {}, _b[Styles.extractBtn] = fileInfo.status === 'success', _b), (_c = {}, _c[Styles.extractBtnGray] = fileInfo.status !== 'success', _c), utilStyles.unDrag, utilStyles.unSelect) }, "\u5F00\u59CB\u63D0\u53D6"))));
};
var RadioBtn = function (_a) {
    var _b, _c, _d;
    var children = _a.children, value = _a.value, selectedRadio = _a.selectedRadio, setSelectedRadio = _a.setSelectedRadio;
    return (React.createElement("div", { onClick: function () { return setSelectedRadio(value); }, className: Styles.radioBtn },
        React.createElement("div", { className: classNames(positionStyles.inTheMiddle, (_b = {}, _b[Styles.radio] = selectedRadio !== value, _b), (_c = {},
                _c[Styles.radioSelected] = selectedRadio === value,
                _c)) },
            React.createElement("div", { className: classNames(utilStyles.dynamic, (_d = {},
                    _d[Styles.radioInner] = selectedRadio !== value,
                    _d[Styles.radioInnerSelected] = selectedRadio === value,
                    _d)) })),
        children));
};
var UploadFileComponent = function (_a) {
    var _b, _c, _d, _e, _f;
    var viewType = _a.viewType, fileInfo = _a.fileInfo, inputRef = _a.inputRef, onChange = _a.onChange, getAttachmentList = _a.getAttachmentList, setShowAttachment = _a.setShowAttachment, attachmentUpload = _a.attachmentUpload;
    var _g = useState(false), dragIn = _g[0], setDragIn = _g[1];
    var timeout = useRef(null);
    var _h = useState(false), showUploadIcon = _h[0], setShowUploadIcon = _h[1];
    var _j = useState(false), showUploadTips = _j[0], setShowUploadTips = _j[1];
    var getTextAndStyle = function () {
        switch (fileInfo.status) {
            case 'success':
                return {
                    text: '重新上传',
                    style: {
                        fontSize: '12px',
                        color: '#999999',
                        cursor: 'pointer',
                    },
                };
            case 'loading':
                return {
                    text: '上传中',
                    style: {
                        fontSize: '12px',
                        color: '#999999',
                    },
                };
            case 'error':
                return {
                    text: '上传失败',
                    style: {
                        fontSize: '12px',
                        color: 'red',
                    },
                };
            default:
                return {
                    text: '',
                    style: {},
                };
        }
    };
    var _k = getTextAndStyle(), text = _k.text, style = _k.style;
    var getPic = function () {
        switch (fileInfo.type) {
            case 'pdf':
                return Pdf_svg;
            case 'wps':
                return Wps_svg;
            case 'WPS':
                return Wps_svg;
            case 'doc':
                return Word_svg;
            case 'docx':
                return Word_svg;
            case 'png':
                return Pic_svg;
            case 'jpg':
                return Pic_svg;
            case 'jpeg':
                return Pic_svg;
            case 'tif':
                return Pic_svg;
            case 'tiff':
                return Pic_svg;
            case 'bmp':
                return Pic_svg;
            case 'ofd':
                return Ofd_svg;
            default:
                return Pic_svg;
        }
    };
    var dragBind = {
        onDragEnter: function (e) {
            setDragIn(true);
            e.preventDefault();
        },
        onDragOver: function (e) {
            setDragIn(true);
            e.preventDefault();
        },
        onDragLeave: function (e) {
            setDragIn(false);
            e.preventDefault();
        },
        onDrop: function (e) {
            setDragIn(false);
            e.preventDefault();
            // TODO
            if (inputRef.current) {
                inputRef.current.files = e.dataTransfer.files;
                onChange();
            }
        },
    };
    var forbidenAttachment = (React.createElement("div", { onClick: function () { var _a; return (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.click(); }, className: classNames(Styles.forbidenAttachment, positionStyles.inTheMiddle) },
        React.createElement("span", { className: classNames(Icons['icon-add'], Styles.icon) }),
        React.createElement("span", null, "\u70B9\u51FB\u6216\u62D6\u62FD\u4E0A\u4F20")));
    var supportAttachment = (React.createElement("div", { className: classNames(Styles.supportAttachment, positionStyles.inTheMiddle, utilStyles.unSelect), onMouseEnter: function () { return setShowUploadIcon(true); }, onMouseLeave: function () { return setShowUploadIcon(false); } },
        showUploadIcon ? (React.createElement("div", { className: classNames(Styles.uploadIconArea, positionStyles['around_center']) },
            React.createElement("div", { onClick: function () {
                    var _a;
                    (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.click();
                    setShowUploadTips(false);
                }, className: classNames(Styles.uploadIcon, positionStyles.inTheMiddle) },
                React.createElement("span", { className: classNames(Icons['icon-computer'], Icons['icon-size']) }),
                React.createElement("span", null, "\u672C\u5730\u6587\u4EF6")),
            React.createElement("div", { onClick: function () {
                    getAttachmentList();
                    setShowAttachment(true);
                    setShowUploadTips(false);
                }, className: classNames(Styles.uploadIcon, positionStyles.inTheMiddle) },
                React.createElement("span", { className: classNames(Icons['icon-attachment'], Icons['icon-size']) }),
                React.createElement("span", null, "\u5355\u636E\u9644\u4EF6")))) : null,
        React.createElement("span", { className: classNames(Icons['icon-add'], Styles.icon) }),
        React.createElement("span", null, "\u70B9\u51FB\u6216\u62D6\u62FD\u4E0A\u4F20")));
    var btnList = (React.createElement(React.Fragment, null,
        React.createElement("div", { onClick: function () { var _a; return (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.click(); }, className: classNames(positionStyles.inTheMiddle, Styles.uploadTipsBtn) }, "\u672C\u5730\u4E0A\u4F20"),
        React.createElement("div", { style: { display: attachmentUpload ? 'flex' : 'none' }, onClick: function () {
                getAttachmentList();
                setShowAttachment(true);
            }, className: classNames(positionStyles.inTheMiddle, Styles.uploadTipsBtn) }, "\u5355\u636E\u9644\u4EF6")));
    var fileView = (React.createElement("div", { className: Styles.fileInfo },
        React.createElement("div", { className: classNames(Styles.fileInfoBody, positionStyles.inTheMiddle) },
            React.createElement("img", { className: classNames(utilStyles.unSelect, utilStyles.unDrag), src: getPic() }),
            React.createElement("span", null, fileInfo.name)),
        React.createElement("div", { className: classNames(Styles.fileInfoFooter, positionStyles.inTheMiddle) },
            React.createElement("span", { className: classNames((_b = {}, _b[Styles.rotateIcon] = fileInfo.status === 'loading', _b), (_c = {}, _c[Icons['icon-loading']] = fileInfo.status === 'loading', _c), (_d = {},
                    _d[Icons['icon-size']] = fileInfo.status === 'loading',
                    _d)) }),
            React.createElement("span", { onMouseEnter: function () {
                    if (timeout.current) {
                        clearTimeout(timeout.current);
                        timeout.current = null;
                    }
                    setShowUploadTips(fileInfo.status === 'success' || fileInfo.status === 'error');
                }, onMouseOver: function () {
                    if (timeout.current) {
                        clearTimeout(timeout.current);
                        timeout.current = null;
                    }
                    setShowUploadTips(fileInfo.status === 'success' || fileInfo.status === 'error');
                }, onMouseLeave: function () {
                    timeout.current = setTimeout(function () { return setShowUploadTips(false); }, 1000);
                }, style: style },
                React.createElement("div", { style: {
                        display: showUploadTips && viewType === 'ie_create_task'
                            ? 'flex'
                            : 'none',
                    }, className: Styles.uploadTips }, btnList),
                React.createElement("span", { onClick: function () {
                        var _a;
                        if (viewType === 'ie_test_task') {
                            (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.click();
                        }
                    } }, text)))));
    return (React.createElement("div", { className: classNames(Styles.uploadFileComponent, (_e = {}, _e[Styles.noDrag] = !dragIn, _e), (_f = {}, _f[Styles.onDragIn] = dragIn, _f)), onDragEnter: function (e) { return dragBind.onDragEnter(e); }, onDragLeave: function (e) { return dragBind.onDragLeave(e); }, onDragOver: function (e) { return dragBind.onDragOver(e); }, onDrop: function (e) { return dragBind.onDrop(e); } }, fileInfo.hasData
        ? fileView
        : attachmentUpload
            ? supportAttachment
            : forbidenAttachment));
};
export var ExtractLoading = function (props) {
    var _a;
    var getPic = function () {
        switch (props.fileInfo.type) {
            case 'pdf':
                return Pdf_svg;
            case 'wps':
                return Wps_svg;
            case 'WPS':
                return Wps_svg;
            case 'doc':
                return Word_svg;
            case 'docx':
                return Word_svg;
            case 'png':
                return Pic_svg;
            case 'jpg':
                return Pic_svg;
            case 'jpeg':
                return Pic_svg;
            case 'tif':
                return Pic_svg;
            case 'tiff':
                return Pic_svg;
            case 'bmp':
                return Pic_svg;
            case 'ofd':
                return Ofd_svg;
            default:
                return Pic_svg;
        }
    };
    var fileInfo = (React.createElement("div", { className: Styles.fileInfo },
        React.createElement("div", { className: classNames(Styles.fileInfoBody, positionStyles.inTheMiddle) },
            React.createElement("img", { className: classNames(utilStyles.unSelect, utilStyles.unDrag), src: getPic() }),
            React.createElement("span", null, props.fileInfo.name)),
        React.createElement("div", { className: classNames(Styles.fileInfoFooter, positionStyles.inTheMiddle) })));
    return (React.createElement("div", { className: classNames(Styles.uploadArea, positionStyles.inTheMiddle) },
        React.createElement("div", { className: classNames(Styles.uploadFilePath, positionStyles.inTheMiddle) },
            React.createElement("div", { className: classNames(Styles.uploadFileComponent) },
                React.createElement("div", { className: Styles.uploadMark },
                    React.createElement("div", { className: classNames((_a = {},
                            _a[Styles.uploadSlider] = props.status === 'loading' || props.status === 'running',
                            _a)) })),
                fileInfo))));
};
export default connect(function (state) {
    return {
        global: state.global,
        control: state.control,
        file: state.file,
    };
})(UploadFile);
